// extracted by mini-css-extract-plugin
export var logo = "_bp-2";
export var logoWrapper = "_bp-1";
export var strip = "_bp-0";